export default __webpack_public_path__ + "static/media/Transition_V02_Energy_116_Radial_Out_Hit_0000000001.57e60692.png";